import { render } from "./SeedJung_ConsultationDetail.vue?vue&type=template&id=9472de52&scoped=true"
import script from "./SeedJung_ConsultationDetail.vue?vue&type=script&lang=js"
export * from "./SeedJung_ConsultationDetail.vue?vue&type=script&lang=js"

import "./SeedJung_ConsultationDetail.vue?vue&type=style&index=0&id=9472de52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9472de52"]])

export default __exports__